import { render, staticRenderFns } from "./ScoreWebAgency.vue?vue&type=template&id=63445364&"
import script from "./ScoreWebAgency.vue?vue&type=script&lang=js&"
export * from "./ScoreWebAgency.vue?vue&type=script&lang=js&"
import style0 from "./ScoreWebAgency.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports